import { ExecutionResult, Transform } from 'casper-js-sdk';
import {
  ContractTypeId,
  Deploy,
  GetDeployResult,
} from '@block-explorer/entities';
import { isTransferDeploy } from '../../../utils/contract';
import { getExecutionResultsFromDeployRawData } from '../../../services/hooks/use-get-execution-results';

export const deriveUpdatedAssociatedKey = (
  deployRawData: GetDeployResult | undefined
): string | undefined => {
  const executionResult: ExecutionResult | null =
    getExecutionResultsFromDeployRawData(deployRawData);

  const transforms = executionResult?.effects ?? [];

  const writeAccountDeployInfo = transforms.filter((obj: Transform) =>
    obj.kind.isWriteAccount()
  );

  const writeAccountTransform =
    writeAccountDeployInfo?.length > 0 ? writeAccountDeployInfo[0] : null;

  return writeAccountTransform?.kind?.parseAsWriteAccount().toPrefixedString();
};

export const hasDeployCustomAction = (deploy: Deploy): boolean => {
  if (!deploy || !deploy.contractPackage) return false;

  const { entryPoint, contractPackage, contractHash, contractPackageHash } =
    deploy;

  const isTransfer =
    isTransferDeploy(contractHash, entryPoint?.name) &&
    !!deploy.transfers?.length;

  const isCustomContractAction =
    contractHash === config.auction_manager_contract_hash ||
    contractHash === config.associated_keys_contract_hash ||
    contractPackageHash === config.cspr_market_v1_contract_package_hash ||
    contractPackageHash === config.cspr_market_contract_package_hash;

  const contractTypeId =
    contractPackage.latest_version_contract_type_id ||
    contractPackage.contract_type_id;

  const isCep18 =
    contractTypeId === ContractTypeId.CustomCep18 ||
    contractTypeId === ContractTypeId.Cep18;

  const isNFT =
    contractTypeId === ContractTypeId.CEP78Nft ||
    contractTypeId === ContractTypeId.CEP47Nft ||
    contractTypeId === ContractTypeId.CustomCEP78Nft ||
    contractTypeId === ContractTypeId.CustomCEP47Nft;

  return isTransfer || isCustomContractAction || isCep18 || isNFT;
};
